export function getPreviewIdAndType(query) {
  let { previewId, typename } = query
  // If we don't have previewId or typename from the query params,
  // check to see if they are in the path
  if (!previewId || !typename) {
    // Check to see if this is a modified path with __preview__ in it
    if (window.location.pathname.includes('__preview__')) {
      const previewPathSuffix = window.location.pathname.substring(window.location.pathname.indexOf('__preview__'))
      const pathParts = previewPathSuffix.split('/')

      // pathParts[0]: '__preview__'
      // pathParts[1]: <previewId>
      // pathParts[2]: 'type'
      // pathParts[3]: '<typename>'
      if (pathParts.length > 3) {
        previewId = pathParts[1]
        typename = pathParts[3]
      }
    }
  }
  return { previewId, typename }
}
